import { Action } from "redux"

import * as actions from "./actions"

export const initialState: ConfirmationDialog.ConfirmationDialog = {
    cancelIcon: "",
    cancelText: "",
    confirmIcon: "",
    confirmText: "",
    isVisible: false,
    title: "",
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: ConfirmationDialog.ConfirmationDialog,
        props: Action,
    ) => ConfirmationDialog.ConfirmationDialog
} = {
    [actions.INITIALIZE]: (
        state,
        {
            cancelIcon,
            cancelText,
            confirmIcon,
            confirmText,
            title,
        }: actions.Initialize,
    ): ConfirmationDialog.ConfirmationDialog => ({
        ...state,
        cancelIcon,
        cancelText,
        confirmIcon,
        confirmText,
        title,
    }),

    [actions.UPDATE_VISIBILITY]: (
        state,
        { isVisible }: actions.UpdateVisibility,
    ): ConfirmationDialog.ConfirmationDialog => ({
        ...state,
        isVisible,
    }),
}

export default function reducer(
    state: ConfirmationDialog.ConfirmationDialog = initialState,
    action: Action,
): ConfirmationDialog.ConfirmationDialog {
    const handler: (
        state: ConfirmationDialog.ConfirmationDialog,
        action: Action,
    ) => ConfirmationDialog.ConfirmationDialog = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
